"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _ = require('lodash');

var PropTypes = require('prop-types');

var React = require('react');

var template = require('./palettePicker.jsx');

var compose = require('../../hoc/compose');

var colorUtil = require('../../util/color');

var displayNames = require('../displayNames');

var PALETTE_PRESETS = require('./palettePickerPresets.json');

var PalettePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(PalettePicker, _React$Component);

  var _super = _createSuper(PalettePicker);

  function PalettePicker(props) {
    var _this;

    _classCallCheck(this, PalettePicker);

    _this = _super.call(this, props);

    _this.getPaletteMainColors = function (palette) {
      return palette.map(function (colorSet) {
        return colorSet[2];
      });
    }; // TODO: consider something cheaper performance-wise


    _this.isSelectedPalette = function (palette) {
      return _.isEqual(palette, _this.props.value);
    };

    _this.isLightColor = function (color) {
      return _(color).thru(colorUtil.hexToHsb).thru(colorUtil.getDistanceToWhite).value() < 3;
    };

    return _this;
  }

  _createClass(PalettePicker, [{
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return PalettePicker;
}(React.Component);

PalettePicker.displayName = displayNames.PALETTE_PICKER;
PalettePicker.propTypes = {
  palettePresets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))),
  onChange: PropTypes.func,
  onPaletteEnter: PropTypes.func,
  onPaletteLeave: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
PalettePicker.defaultProps = {
  palettePresets: PALETTE_PRESETS,
  onPaletteEnter: _.noop,
  onPaletteLeave: _.noop
};
module.exports = compose(PalettePicker);